import { render, staticRenderFns } from "./ShopItemComponent.vue?vue&type=template&id=a4e7afb0&"
import script from "./ShopItemComponent.vue?vue&type=script&lang=ts&"
export * from "./ShopItemComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ShopItemComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports